<div class="container" id="admin">
  <h1 ng-show="!searchResults.length" aria-hidden="false" class="" style="">Search for Dealer License</h1>
  <div class="row">
    <div class="col-md-12" *ngIf="!isSearchPerformed" aria-hidden="false" style="">
      <p class="lead">To find a license record, enter information for one of the following items.</p>
      <form  [formGroup]="searchForm" (ngSubmit)="onSubmit()">
        <div class="row">
          <div class="col-xl-3 col-lg-4 col-md-5">
            <div class="form-group">
              <label for="dealerLicenseNo">Dealer Tracking No.</label>
              <input [attr.disabled]="searchForm.get('dealerName').value ? true : null" type="text" formControlName="dealerLicenseNo" name="dealerLicenseNo" id="dealerLicenseNo" class="form-control"
                     aria-label="license number">
                <div *ngIf="searchForm.get('dealerLicenseNo').hasError('validDealerId')  && !searchForm.pristine" role="alert" class="formError text-danger" aria-live="assertive">
                  Please, enter a valid License Number.
                </div>

            </div>
          </div>
          <div class="col-lg-1 col-md-2 text-center">
            <span class="adminSearchOr">or</span>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-5">
            <div class="form-group isRequired">
              <label for="searchDealerName">Dealer Name</label>
              <input [attr.disabled]="searchForm.get('dealerLicenseNo').value ? true : null" type="text" formControlName="dealerName" name="dealerName" id="searchDealerName" class="form-control" aria-label="dealer name">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div *ngIf="formSubmitAttempt && searchForm.hasError('oneParamRequired')" class="alert alert-danger" role="alert">
              <span> Please enter information for one of the above items.</span>
            </div>
            <div *ngIf="formSubmitAttempt && searchForm.hasError('tooManyResults')" class="alert alert-danger" role="alert">
              <span> The number of search results exceeded the upper limit. Please refine your search.</span>
            </div>
            <div *ngIf="(searchForm.touched || formSubmitAttempt) && searchForm.hasError('noResultsFound')" class="alert alert-danger" role="alert">
              <span *ngIf="searchForm.get('dealerName').value"> No results found. Please edit your search.</span>
              <span *ngIf="searchForm.get('dealerLicenseNo').value"> No such dealer number found. Please edit your search.</span>
            </div>

            <button type="submit" class="btn btn-primary btn-space" [disabled]="(searchForm.touched || formSubmitAttempt) && searchForm.invalid"><i class="fas fa-search"></i> Search</button>
            <button type="button" (click)="startNewSearch()" class="btn btn-secondary"><i class="fas fa-times"></i>
              Clear</button>
          </div>
        </div>
      </form>
    </div>
    <div class="col-md-6 ng-hide" *ngIf="isSearchPerformed" id="searchResults" aria-hidden="true" style="">
      <p class="lead">Select a license number to continue. If the sought licensee is not listed, try a <a href="#" (click)="startNewSearch()">new search</a>.</p>
      <div class="row">
        <div class="col-md-12">
          <div class="report">
            <table class="table table-bordered table-responsive-sm mftable" appDatatableKeyboard [mfData]="searchResults" #mf="mfDataTable" [mfRowsOnPage]="numberOfDisplayedRows">
              <thead class="thead-dark">
              <tr>
                <th [ngClass]="{'active': activeColumn === 1}">
                  <mfDefaultSorter (click)="activeColumn = 1" by="licenseNumber">Dealer Tracking No. <i class="fa fa-sort"
                                                                                              aria-hidden="true"></i></mfDefaultSorter>
                </th>
                <th [ngClass]="{'active': activeColumn === 2}">
                  <mfDefaultSorter (click)="activeColumn = 2" by="businessName">Dealer Name <i class="fa fa-sort"
                                                                                                aria-hidden="true"></i></mfDefaultSorter>
                </th>
              </tr>
              </thead>
              <tfoot *ngIf="!isTablePaginationHidden">
              <tr>
                <td colspan="100%" class="pagination-container">
                  <mfBootstrapPaginator [rowsOnPageSet]="[10,25,50,100]"></mfBootstrapPaginator>
                </td>
              </tr>
              </tfoot>
              <tbody>
                <tr *ngFor="let item of mf.data">
                  <td><a href="#/admin/dealer/{{item.licenseNumber}}">{{item.licenseNumber}}</a></td>
                  <td><a href="#/admin/dealer/{{item.licenseNumber}}">{{item.businessName}}</a></td>
                </tr>
              </tbody>
            </table>
            <span class="ng-binding">Showing {{(mf.activePage - 1)  * mf.rowsOnPage + 1}}-{{(mf.activePage * mf.rowsOnPage > searchResults.length ? searchResults.length : mf.activePage * mf.rowsOnPage) }} of {{searchResults.length}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
